<div
    class="collapsibles-wrapper"
    [class.has-active]="activeTab !== null"
    [class.scroll-past-threshold]="isCommentsScrolledPast50px"
    [class.variant-station]="isStationVariant"
    [class.station-open]="isStationVariant && activeTab === 'comments'">
    <div class="buttons-row" [class.single-button]="onlyActivityLog">
        @if (showComments) {
            <app-text-button
                class="toggle"
                [class.is-active]="activeTab === 'comments'"
                (clicked)="toggleComments()">
                <span class="text-s">{{ commentsButtonText }}</span>
                <mat-icon
                    svgIcon="chevron-down"
                    class="toggle__icon"
                    [attr.toggled]="activeTab === 'comments'" />
            </app-text-button>
        }
        @if (!isStationVariant) {
            <app-text-button
                class="toggle"
                [class.is-active]="activeTab === 'activityLog'"
                (clicked)="toggleActivityLog()">
                <span class="text-s">{{ activityLogButtonText }}</span>
                <mat-icon
                    svgIcon="chevron-down"
                    class="toggle__icon"
                    [attr.toggled]="activeTab === 'activityLog'" />
            </app-text-button>
            @if (isEscalationToggleVisible) {
                <app-text-button
                    class="toggle"
                    [class.is-active]="activeTab === 'escalation'"
                    *wfeFeatureFlag="'EscalationEnabled'"
                    (clicked)="toggleEscalation()">
                    <span class="text-s">{{ escalationButtonText }}</span>
                    <mat-icon
                        svgIcon="chevron-down"
                        class="toggle__icon"
                        [attr.toggled]="activeTab === 'escalation'" />
                </app-text-button>
            }
        }
    </div>

    @if (activeTab === 'comments') {
        <div class="content-area">
            <div class="comments-container">
                <div
                    #commentsList
                    class="comments-list"
                    (mouseenter)="onCommentsMouseEnter()"
                    (mouseleave)="onCommentsMouseLeave()"
                    (scroll)="onCommentsScroll($event)"
                    (wheel)="onCommentsWheel($event)"
                    [class.scroll-enabled]="isCommentsScrollEnabled">
                    <div
                        class="add-comment"
                        [class.add-comment--station]="isStationVariant">
                        <div class="add-comment__box">
                            <textarea
                                #commentTextarea
                                class="add-comment__textarea text-s text-light"
                                rows="1"
                                placeholder="Add a comment."
                                [maxLength]="commentMaxLength"
                                [formControl]="newCommentControl"
                                (paste)="onCommentPaste()"
                                (input)="onCommentInput($event)"></textarea>

                            @if (newCommentControl.value.trim()) {
                                <div class="add-comment__actions">
                                    <app-tooltip>
                                        <button
                                            trigger
                                            type="button"
                                            class="add-comment__clear"
                                            [disabled]="
                                                !newCommentControl.value ||
                                                isAddingComment
                                            "
                                            (click)="clearComment()"
                                            aria-label="Cancel">
                                            <mat-icon svgIcon="close" />
                                        </button>
                                        <div content>Cancel</div>
                                    </app-tooltip>

                                    <div class="add-comment__divider"></div>

                                    <app-flat-button
                                        class="add-comment__save"
                                        variant="status-blue"
                                        [disabled]="isCommentSaveDisabled"
                                        (clicked)="submitComment()">
                                        Save
                                    </app-flat-button>
                                </div>
                            }
                        </div>

                        <p class="add-comment__counter text-xs text-end">
                            {{ newCommentControl.value.length }}/{{
                                commentMaxLength
                            }}
                        </p>
                    </div>

                    @if (comments.length === 0 && isLoadingComments) {
                        <div class="comments-loader">
                            <app-loader />
                        </div>
                    } @else if (comments.length === 0) {
                        <p class="no-comments text-start color-gray14 py-3">
                            No comments to show.
                        </p>
                    } @else {
                        @for (comment of comments; track comment.id) {
                            <div class="comment-item">
                                <div class="comment-header">
                                    <div class="comment-author-section">
                                        @if (
                                            shouldShowAuthorTooltip(
                                                comment.commentator.fullName
                                            )
                                        ) {
                                            <app-tooltip>
                                                <span
                                                    trigger
                                                    class="comment-author text-xs color-gray18">
                                                    {{
                                                        comment.commentator
                                                            .fullName
                                                    }}
                                                </span>
                                                <div content class="text-xs">
                                                    {{
                                                        comment.commentator
                                                            .fullName
                                                    }}
                                                </div>
                                            </app-tooltip>
                                        } @else {
                                            <span
                                                class="comment-author text-xs color-gray18">
                                                {{
                                                    comment.commentator.fullName
                                                }}
                                            </span>
                                        }
                                        @if (comment.commentator.role === -1) {
                                            <span
                                                class="comment-role text-xxs color-gray18 text-light">
                                                <span class="mr-1"> • </span>
                                                FORMER USER - ACCESS REMOVED
                                            </span>
                                        } @else {
                                            <span
                                                class="comment-role text-xxs color-gray18 text-light">
                                                <span class="mr-1"> • </span>
                                                {{
                                                    RoleLabel[
                                                        comment.commentator.role
                                                    ] | uppercase
                                                }}
                                            </span>
                                        }
                                    </div>
                                    <span
                                        class="comment-date text-xs text-light">
                                        {{ formatDate(comment.commentedAt) }}
                                    </span>
                                </div>
                                <div class="comment-text text-s">
                                    {{ comment.message }}
                                </div>
                            </div>
                        }
                        @if (isLoadingComments) {
                            <div class="comments-loader">
                                <app-loader />
                            </div>
                        }
                    }
                </div>
            </div>
        </div>
    }

    @if (activeTab === 'activityLog') {
        <div class="content-area p-3">
            <p class="title pl-2 mb-2">Activity Log</p>
            <app-table
                variant="secondary"
                noRowsText="No activity logs to show."
                [hideBorder]="true"
                [suppressRowHoverHighlight]="true"
                [suppressCellFocus]="true"
                [pagination]="false"
                [floatingFilter]="false"
                [columnDefs]="activityLogColumnDefs"
                [pageSize]="-1"
                [gridOptions]="activityLogGridOptions"
                (gridReady)="onActivityLogGridReady($event)" />
            <div #activityLogEnd></div>
        </div>
    }

    @if (activeTab === 'escalation' && !escalationError) {
        <div class="content-area p-3">
            <p class="title flex items-center justify-space-between pl-2 mb-2">
                <span class="flex items-center">
                    Escalation
                    <app-tooltip>
                        <mat-icon trigger svgIcon="info" />
                        <div
                            content
                            class="grid gap-10"
                            style="max-height: 300px">
                            @for (item of escalationLevels; track $index) {
                                <div>
                                    <p class="text-xs uppercase color-gray14">
                                        {{ item.label }} •
                                        {{
                                            getEscalationRecipientsCount(
                                                item.level
                                            )
                                        }}
                                        Recipients
                                    </p>
                                    <div>
                                        <p>
                                            <span class="color-gray10">
                                                To:
                                            </span>
                                            {{ item.toRecipients }}
                                        </p>
                                        <p>
                                            <span class="color-gray10">
                                                Cc:
                                            </span>
                                            {{ item.ccRecipients }}
                                        </p>
                                    </div>
                                </div>
                            }
                        </div>
                    </app-tooltip>
                </span>
                <app-text-button class="hidden">
                    <span class="flex items-center text-sm">
                        <mat-icon svgIcon="stop" />
                        Stop escalation
                    </span>
                </app-text-button>
            </p>
            @if (escalationStarted) {
                <div
                    class="levels text-s pl-2 items-center justify-space-between bordered">
                    @for (item of escalationLevels; track $index) {
                        <div class="item">
                            <p
                                class="color-gray14 flex gap-12 justify-space-between">
                                <span class="uppercase">
                                    {{ item.label }}
                                </span>
                                {{ item.escalationDate | utcToLocalDate }}
                            </p>
                            <p class="mt-1">
                                @if (item.isEscalated) {
                                    <span class="escalated text-semi">
                                        Escalated
                                    </span>
                                } @else {
                                    @if (
                                        $index > 0 &&
                                        escalationLevels[$index - 1].isEscalated
                                    ) {
                                        <span class="next">Next</span>
                                    } @else {
                                        -
                                    }
                                }
                            </p>
                        </div>
                    }
                </div>
            } @else {
                <p class="text-s pl-2 color-gray10">
                    No escalation information to show.
                </p>
            }
        </div>
    }
</div>
<div #contentEnd></div>
